const emptySurvey: Survey = {
  id: '0',
  name: '',
  description: '',
  questions: [],
  totalNumberOfQuestions: 0,
}

export default emptySurvey
